import { render, staticRenderFns } from "./OrganizerItem.vue?vue&type=template&id=fe7456e0&scoped=true&"
import script from "./OrganizerItem.vue?vue&type=script&lang=js&"
export * from "./OrganizerItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerItem.vue?vue&type=style&index=0&id=fe7456e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7456e0",
  null
  
)

export default component.exports